<template>
  <layout-content>
    <template #toolbar>
      <period-time
        :query="query"
        :start-date-picker-options="startDatePickerOptions"
        :end-date-picker-options="endDatePickerOptions"
        :show-options="showOptions"
      >
        <el-cascader
          v-model="value"
          size="small"
          collapse-tags
          :props="props"
          :options="filterSites"
          :clearable="false"
          :show-all-levels="false"
          style="width: 220px;"
          @change="changeLabel"
        >
        </el-cascader>
        <!-- <site-query :sites="filterSites" :query="query" /> -->
        <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border /> -->

        <el-button
          :disabled="canNotSearch"
          type="orange"
          size="small"
          icon="el-icon-search"
          @click="onSearchBtnClick"
        >查询</el-button>
      </period-time>
    </template>

    <template #body>
      <data-wrapper>
        <template #header>
          <display-type
            :default-display-type.sync="displayType"
            style="margin-left:20px;"
            @change="onDisplayTypeChanged"
          />

          <el-radio-group :disabled="displayType != 1" v-model="type" size="small" @change="formatData(dataList)">
            <el-radio-button label="capture">捕集率</el-radio-button>
            <el-radio-button label="effective">有效率</el-radio-button>
          </el-radio-group>
        </template>

        <section v-if="displayType === 1">
          <div class="ratio-data-table" v-for="(data, i) in dataList" :key="i">
            <div class="ratio-data-table-header">
              <span>{{data.siteName}}</span>
              <el-link type="success" @click="onExportBtnClick(data)">导出</el-link>
            </div>

            <div class="ratio-data-table-body">
              <!-- <data-table
                ref="dataTable"
                :columns="data.headerColumns"
                :highlight-data-time="''"
                :data="data.tableData"
              /> -->
              <z-table
                ref="dataTable"
                :columns="data.headerColumns"
                :data="data.tableData"
                selected-row-style
                class="legend-table no-wrap-table"
              >
                <template v-for="(column, i) in data.headerColumns" :slot="column.prop" :lable="column.label" slot-scope="{row}">
                  <div :key="i" :class="` ${row[column.prop + 'Integral'] ? 'integral-data' : 'normal-data'}`">
                    {{row[column.prop]}}
                  </div>
                </template>
              </z-table>
            </div>
          </div>
        </section>

        <section v-else style="flex: 1">
          <e-chart ref="chart" />
        </section>
      </data-wrapper>
    </template>
  </layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import LayoutContent from '../../../../components/Layout/Content'
import PeriodTime from '../../../../components/Data/PeriodTime'
import DataTable from '../../../../components/Data/DataTable'
import CSVDownloader from '../../../../utils/CSVDownloader'
import ZTable from '../../02Normal/08VOCs-Data-Compare/ZTable'
export default {
  name: 'DataManagementGatherEffective',
  routeInfo: {
    label: '有效/捕集率统计'
  },
  extends: BaseFactorData,
  components: {LayoutContent, PeriodTime, ZTable, DataTable},
  data () {
    return {
      value: [],
      shareScopeEnd: [],
      props: {
        multiple: true,
        children: 'devices',
        label: 'name',
        value: 'id'
      },
      query: {
        granularity: 'day',
        isMultipleIntegral: true
      },
      type: 'capture',
      dataList: [],
      chartData: [],
      displayType: 1
    }
  },
  computed: {
    showOptions () {
      return ['day', 'month', 'year']
    },
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    }
  },
  methods: {
    changeLabel (val) {
      let changeFlag = false
      let changeItem = []
      if (this.shareScopeEnd.length === 0) {
        this.value = val
      } else {
        this.value.forEach(el => {
          if (el[0] !== this.shareScopeEnd[0][0]) {
            changeFlag = true
            changeItem.push(el)
          }
        })
      }
      if (changeFlag) {
        this.value = []
        this.value.push(...changeItem)
      }

      this.query.factorIds = [...new Set(val.map(el => {
        let {filterSiteMap} = this
        let siteDevice = filterSiteMap[el[0]].devices
        this.query.siteIds = [el[0]]

        let Ids = []
        siteDevice.forEach(item => {
          if (item.id === el[1]) {
            Ids.push(...item.siteDeviceFactors.map(factor => factor.factorId))
          }
        })
        return Ids
      }).flat())]
      this.shareScopeEnd = this.value
    },
    setFactorIds (sites) {
      let {filterSites} = this
      let siteDevices = []
      if (sites) {
        if (sites.length === 0) {
          this.query.factorIds = []
          return false
        }
        siteDevices = sites.map(el => el.devices).flat()
      } else {
        siteDevices = filterSites.slice(0, this.minSiteSelectNumber).map(el => el.devices)
      }

      if (siteDevices.length > 0) {
        let siteDevicesFactors = siteDevices.flat()[0] ? siteDevices.flat()[0].siteDeviceFactors : []
        if (siteDevicesFactors.length > 0) {
          this.value = [[siteDevices.flat()[0].siteId, siteDevices.flat()[0].id]]
          this.shareScopeEnd = [[siteDevices.flat()[0].siteId, siteDevices.flat()[0].id]]
          let siteDevicesFactorsIds = [...new Set(siteDevicesFactors.map(el => el.factorId))]

          this.query.factorIds = siteDevicesFactorsIds
          return true
        }
      }
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length > 0) {
        let {query: {siteIds}} = this

        if (siteIds.length === 0) {
          siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        }

        this.afterSetSiteIds()
      }
    },
    siteChange () {
      let {query: {siteIds}, filterSiteMap} = this
      let filterSites = siteIds.map(el => filterSiteMap[el])
      this.setFactorIds(filterSites)
      this.getData()
    },
    changeQueryTime (query) {
      let data = JSON.parse(JSON.stringify(query))
      delete data.dataType
      delete data.isAuditCompleted
      let {granularity, beginTime, endTime} = query
      switch (granularity) {
        case 'year':
          data.beginTime = new Date(beginTime).format('YYYY/01/01 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/12/31 23:59:59')
          break
        case 'month':
          let date = new Date(endTime)
          let year = date.getFullYear()
          let month = date.getMonth() + 1
          data.beginTime = new Date(beginTime).format('YYYY/MM/01 00:00:00')
          data.endTime = new Date(year, month, 0).format('YYYY/MM/DD 23:59:59')
          break
        case 'day':
          data.beginTime = new Date(beginTime).format('YYYY/MM/DD 00:00:00')
          data.endTime = new Date(endTime).format('YYYY/MM/DD 23:59:59')
          break
      }

      return data
    },
    getData () {
      let query = this.changeQueryTime(this.query)
      if (query.factorIds.length === 0) {
        return
      }

      this.changeLoadStatus(true)
      if (this.displayType === 1) {
        this.$api.Effective.getGranularity(query).then(data => {
          this.setHeaderColumns(data)
          setTimeout(() => {
            this.$refs.dataTable.forEach(el => {
              el.doLayout()
            })
          }, 0)
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      } else {
        this.$api.Effective.getChartData(query).then(data => {
          this.formatChartData(data)
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }
    },
    // getSiteDevicesFactorIds (siteId) {
    //   let {filterSiteMap} = this
    //   return filterSiteMap[siteId].devices.map(el => {
    //     let factorIds = el.siteDeviceFactors.map(factor => factor.factorId)
    //     return factorIds
    //   }).flat(Infinity)
    // },
    setHeaderColumns (data) {
      let {filterSiteMap, factorMap, query: {factorIds}} = this

      data.forEach(el => {
        el.siteName = filterSiteMap[el.siteId] ? filterSiteMap[el.siteId].name : '--'
        // // 获取此站点下已选中设备的所有因子
        // let siteDevicesFactorIds = this.getSiteDevicesFactorIds(el.siteId)
        let headerColumns = factorIds.filter(factorId => {
          const factor = factorMap[factorId]
          if (!factor) {
            return false
          }

          return !/标况|实况/.test(factor.name)
        }).map(factorId => {
          return {
            prop: factorId,
            label: factorMap[factorId] ? factorMap[factorId].name : '--',
            width: 150,
            align: 'left'
          }
        })

        headerColumns.unshift({
          prop: 'dataTime',
          label: '时间',
          width: 200,
          align: 'left',
          fixed: true
        })

        el.headerColumns = headerColumns
      })

      this.formatData(data)
    },
    formatData (data) {
      let {type, query: {isMultipleIntegral}, factorMap} = this
      const factorIds = this.query.factorIds.filter(factorId => {
        const factor = factorMap[factorId]
        if (!factor) {
          return false
        }

        return !/标况|实况/.test(factor.name)
      })

      data.forEach(el => {
        // 获取此站点下所有因子
        // let siteDevicesFactorIds = this.getSiteDevicesFactorIds(el.siteId)

        let rateData = el.data
        if (rateData.length === 0) {
          el.tableData = []
        } else {
          let tableData = rateData.map(item => {
            // 站点仪器因子ID map
            let siteDevicesFactorIdsMap = factorIds.reduce((map, item) => {
              map[item] = '--'
              return map
            }, {})
            for (let key in item) {
              if (key !== 'dataTime') {
                if (type === 'capture') {
                  siteDevicesFactorIdsMap[key] = (item[key]['captureRate'] * 100).toFixed(2) + '%'
                } else {
                  siteDevicesFactorIdsMap[key] = Number.isFinite(item[key].value) ? (item[key].unit === '%' ? Number(item[key].value.toFixed(2)) : item[key].value) + item[key].unit : (item[key]['effectiveRate'] * 100).toFixed(2) + '%'
                  if (isMultipleIntegral) {
                    siteDevicesFactorIdsMap[key + 'Integral'] = item[key].isHaveIntegral || false
                  } else {
                    siteDevicesFactorIdsMap[key + 'Integral'] = false
                  }
                }
              }
            }

            return {
              dataTime: item.dataTime,
              ...siteDevicesFactorIdsMap
            }
          })

          el.tableData = tableData
        }
      })

      this.dataList = data
    },
    onExportBtnClick (datas) {
      let {currentQuery: {beginTime, endTime}} = this
      let {headerColumns, tableData, siteName} = datas
      let filename = `${siteName}_${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}`

      CSVDownloader([headerColumns.map(column => column.label)].concat(tableData.map(data => headerColumns.map(column => {
        let back = ''
        if (data[column.prop + 'Integral']) {
          back = data[column.prop] + '(重积分)'
        } else {
          back = data[column.prop]
        }
        return back
      }))), filename)
    },
    onDisplayTypeChanged () {
      this.getData()
    },
    formatChartData (data) {
      const { value } = this
      if (value.leng === 0) {
        return
      }

      const siteId = value[0][0]
      const site = this.filterSites.find(site => site.id === siteId)
      if (!site) {
        return
      }

      const siteDeviceIdMap = value.reduce((map, [, siteDeviceId]) => {
        map[siteDeviceId] = true
        return map
      }, {})

      const devices = site.devices.filter(device => siteDeviceIdMap[device.id])
      const siteDeviceDataMap = data.reduce((map, data) => {
        map[data.siteDeviceId] = data
        return map
      }, {})
      const { query } = this
      const chartOpt = {
        title: {
          text: `${site.name}${new Date(query.beginTime).format('YYYY.MM.DD')}-${new Date(query.endTime).format('YYYY.MM.DD')}`,
          left: 'center',
          top: 10
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          top: 40
        },
        grid: {
          top: 90,
          right: 20,
          bottom: 20,
          left: 20,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: devices.map(device => device.name.replace(/((颗粒物)?分析仪|(自动|在线)?(监测)?仪)$/, ''))
        },
        yAxis: {
          type: 'value',
          name: '%',
          max: 100
        },
        series: [{
          name: '捕集率',
          type: 'bar',
          barMaxWidth: 40,
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%',
            fontSize: 11
          },
          data: devices.map(device => {
            const data = siteDeviceDataMap[device.id]
            return data ? Number((data.captureRate * 100).toFixed(2)) : null
          })
        }, {
          name: '有效率',
          type: 'bar',
          barMaxWidth: 40,
          label: {
            show: true,
            position: 'top',
            formatter: '{c}%',
            fontSize: 10
          },
          data: devices.map(device => {
            const data = siteDeviceDataMap[device.id]
            if (!data) {
              return null
            }

            let value = data.isHaveIntegral ? data.effectiveIntegralRate : data.effectiveRate
            return Number.isFinite(value) ? Number((value * 100).toFixed(2)) : null
          })
        }]
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style lang="scss" scoped>
.ratio-data-table {
  display: grid;
  grid-template-rows: 1.8em 400px;
  padding-bottom: 22px;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .ratio-data-table-header {
    display: grid;
    grid-template-columns: auto max-content;
    align-items: center;
    padding: 0 10px;
    background: linear-gradient(90deg, #fbc15a 0, #fff);
    color: #ffffff;
    font-weight: 600;
  }
}
.no-wrap-table {
  --z-table-white-space: nowrap;
}
legend {
  font-size: 16px;
  padding: 0 1em;
  color: #303133;
  text-align: center;
}
.z-table {
  min-height: 0;
}
.integral-data {
  color: #409EFF;
}
.toolbar .el-checkbox {
  font-size: 17px;
  height: 32px;

  /deep/ .el-checkbox__label {
    line-height: 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/01Data-Statistical/99Gather-Effective/index.vue